import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <g transform="translate(25.000000,25.000000)">
          <path
            d="M20.6064 27.6738C20.6064 26.2904 20.1182 25.2324 19.1416 24.5C18.165 23.7513 16.4072 22.9701 13.8682 22.1562C11.3291 21.3262 9.31901 20.5124 7.83789 19.7148C3.80143 17.5339 1.7832 14.596 1.7832 10.9014C1.7832 8.98079 2.32031 7.27181 3.39453 5.77441C4.48503 4.26074 6.03939 3.08073 8.05762 2.23438C10.0921 1.38802 12.3708 0.964844 14.8936 0.964844C17.4326 0.964844 19.695 1.42871 21.6807 2.35645C23.6663 3.2679 25.2044 4.56185 26.2949 6.23828C27.4017 7.91471 27.9551 9.81901 27.9551 11.9512H20.6309C20.6309 10.3236 20.1182 9.06217 19.0928 8.16699C18.0674 7.25553 16.627 6.7998 14.7715 6.7998C12.9811 6.7998 11.5895 7.18229 10.5967 7.94727C9.60384 8.69596 9.10742 9.6888 9.10742 10.9258C9.10742 12.0814 9.68522 13.0498 10.8408 13.8311C12.0127 14.6123 13.7298 15.3447 15.9922 16.0283C20.1589 17.2816 23.1943 18.8359 25.0986 20.6914C27.0029 22.5469 27.9551 24.8581 27.9551 27.625C27.9551 30.7012 26.7913 33.1182 24.4639 34.876C22.1364 36.6175 19.0033 37.4883 15.0645 37.4883C12.3301 37.4883 9.83984 36.9919 7.59375 35.999C5.34766 34.9899 3.63053 33.6146 2.44238 31.873C1.27051 30.1315 0.68457 28.1133 0.68457 25.8184H8.0332C8.0332 29.7409 10.377 31.7021 15.0645 31.7021C16.806 31.7021 18.165 31.3522 19.1416 30.6523C20.1182 29.9362 20.6064 28.9434 20.6064 27.6738Z"
            fill="currentColor"
          />
        </g>
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
